import { Component, OnInit, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { WINDOW } from '../../Services/window/window.service';
import { HeaderService } from '../../Services/header/header.service';
import { FooterService } from '../../Services/footer/footer.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  windowHeight = 800;

  constructor(private titleService: Title, private metaService: Meta,
              public translate: TranslateService,
              @Inject(WINDOW) private window,
              private header: HeaderService,
              private footer: FooterService) { }

  ngOnInit() {
    this.setPageMetaData();
    this.setWindowHeight();
    this.header.isSolidBg(false);
    this.header.headerBGChangeAble(true);
    this.header.showMainNav(true);
    this.header.hasNoHeader(false);
    this.header.tripHeader(false);
    this.header.title(null);
    this.header.secondTitle(null);
    this.header.class('');
    this.footer.isSlaaskEnabled(false);
    this.footer.footerVisibility(true);
  }

  setWindowHeight() {
    this.windowHeight = this.window.innerHeight;
  }

  setPageMetaData() {
    this.translate.stream('strings.notFound.meta.title').subscribe((text: string) => {
      this.titleService.setTitle(text);
      this.metaService.updateTag({ name: 'subject', content: text }, `name='subject'`);
      this.metaService.updateTag({ name: 'twitter:title', content: text }, `name='twitter:title'`);
      this.metaService.updateTag({ property: 'og:title', content: text }, `property='og:title'`);
    });

    this.translate.stream('strings.notFound.meta.keywords').subscribe((text: string) => {
      this.metaService.updateTag({ name: 'keywords', content: text }, `name='keywords'`);
    });

    this.translate.stream('strings.notFound.meta.description').subscribe((text: string) => {
      this.metaService.updateTag({ name: 'description', content: text }, `name='description'`);
      this.metaService.updateTag({ name: 'twitter:description', content: text }, `name='twitter:description'`);
      this.metaService.updateTag({ property: 'og:description', content: text }, `property='og:description'`);
    });

    //  this dependent on the URL we are one - and based on the app schema.
    this.metaService.updateTag({ name: 'url', content: environment.metaUrl + '404' }, `name='url'`);
    this.metaService.updateTag({ property: 'al:ios:url', content: 'luckytrip://404' }, `property='al:ios:url'`);
    this.metaService.updateTag({ property: 'al:android:url', content: 'luckytrip://404' }, `property='al:android:url'`);
    this.metaService.updateTag({ property: 'al:web:url', content: environment.metaUrl + '404' }, `property='al:al:web:url'`);
    // this.metaService.updateTag({ name: 'apple-itunes-app', content: 'app-id=973059290, app-argument=luckytrip://404' },
    // `name='apple-itunes-app'`);
    this.metaService.updateTag({ name: 'apple-itunes-app', content: 'app-id=973059290, app-argument=' + environment.metaUrl + '404' },
    `name='apple-itunes-app'`);
    this.metaService.updateTag({ name: 'twitter:url', content: environment.metaUrl + '404' }, `name='twitter:url'`);
    this.metaService.updateTag({ property: 'og:url', content: environment.metaUrl + '404' }, `property='og:url'`);

    this.metaService.updateTag({ name: 'twitter:image', content: environment.metaUrl + 'assets/common/imgs/meta/general.jpg' },
    `name='twitter:image'`);
    this.metaService.updateTag({ property: 'og:image', content: environment.metaUrl + 'assets/common/imgs/meta/general.jpg' },
    `property='og:image'`);
  }

}
